import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import { FormattedHeading } from '../../../i18n/components/';
import { ExclusionRulesEditor } from '../';

import { FlagContext } from '../../../flags/Flags';
import { withSession } from '../../../i18n/containers/AppInit.js';

import './ExclusionRulesPanel.scss';

class ExclusionRulesPanel extends Component {
  addNewRule() {
    let exclusion = [];
    if (this.validateRules(this.props.rules.exclusion)) {
      if (this.props.rules.exclusion) {
        exclusion = [...this.props.rules.exclusion];
      }
      const assetKey = this.props.assetAttributes?.[0]?.name;
      const profileKey = this.props.profileAttributes?.[0]?.name;
      exclusion.push({
        assetKey: assetKey,
        assetValue: undefined,
        consumerKey: profileKey,
        consumerValue: undefined
      });
      this.props.actions.updateRules({
        ...this.props.rules,
        exclusion
      });
    }
  }

  deleteRule(ruleIndex) {
    if (
      this.props.rules.exclusion &&
      ruleIndex >= 0 &&
      ruleIndex < this.props.rules.exclusion.length
    ) {
      const exclusion = [...this.props.rules.exclusion];
      exclusion.splice(ruleIndex, 1);
      this.props.actions.updateRules({
        ...this.props.rules,
        exclusion
      });
    }
  }

  updateRules(ruleIndex, update) {
    if (
      this.props.rules.exclusion &&
      ruleIndex >= 0 &&
      ruleIndex < this.props.rules.exclusion.length
    ) {
      const rule = {
        ...this.props.rules.exclusion[ruleIndex],
        ...update
      };
      const exclusion = [...this.props.rules.exclusion];
      exclusion.splice(ruleIndex, 1, rule);
      this.props.actions.updateRules({
        ...this.props.rules,
        exclusion
      });
    }
  }

  saveRules(session) {
    return () => {
      let exclusion = [];
      if (this.props.rules.exclusion) {
        exclusion = [...this.props.rules.exclusion];
      }

      if (this.validateRules(exclusion)) {
        this.props.actions.saveRules(
          {
            ...this.props.rules,
            exclusion
          },
          { ruleType: 'exclusion', cToken: session.cToken }
        );
      }
    };
  }

  validateRules(rules) {
    // if rules are not set
    rules = rules || [];
    let validationResult = rules.reduce((validity, rule) => {
      let isRuleValid = true;
      if (
        rule.assetKey === undefined ||
        rule.consumerKey === undefined ||
        rule.assetValue === undefined ||
        rule.assetValue.trim() === '' ||
        rule.consumerValue === undefined ||
        rule.consumerValue.trim() === ''
      ) {
        isRuleValid = false;
      }
      return validity && isRuleValid;
    }, true);
    return validationResult;
  }

  dirty() {
    return (
      JSON.stringify(this.props.rules.exclusion) !==
      JSON.stringify(this.props.loadedRules.exclusion)
    );
  }

  saveAllowed(flags) {
    if (this.props.rules.exclusion && this.props.rules.exclusion.length > 0) {
      return (
        !(flags && flags.isReadonly) &&
        this.dirty() &&
        this.validateRules(this.props.rules.exclusion)
      );
    } else {
      return !(flags && flags.isReadonly) && this.dirty();
    }
  }

  newRuleAllowed(flags) {
    if (this.props.rules.exclusion && this.props.rules.exclusion.length > 0) {
      return (
        !(flags && flags.isReadonly) &&
        this.validateRules(this.props.rules.exclusion)
      );
    } else {
      return !(flags && flags.isReadonly);
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const saveRuleLabel = formatMessage({
      id: 'components.ecs.rules.save'
    });
    const cancelRuleLabel = formatMessage({
      id: 'components.ecs.rules.cancel'
    });

    return withSession(session => {
      return (
        <FlagContext.Consumer>
          {flags => (
            <div className="slds-grid slds-wrap">
              <div className="slds-form exclusion-panel">
                <div className="exclusion-panel-header">
                  <p>
                    <FormattedMessage id="components.ecs.rules.exclusion.subHeader" />
                  </p>
                  <FormattedHeading id="components.ecs.rules.exclusion.header" />
                </div>
                <ExclusionRulesEditor
                  actions={this.props.actions}
                  assetAttributes={this.props.assetAttributes}
                  profileAttributes={this.props.profileAttributes}
                  exclusionRules={this.props.rules.exclusion}
                  loadedExclusionRules={this.props.loadedRules.exclusion}
                  canAddRule={!this.newRuleAllowed(flags)}
                  onAddRule={this.addNewRule.bind(this)}
                  onDeleteRule={this.deleteRule.bind(this)}
                  onRuleChange={this.updateRules.bind(this)}
                />
                <div className="footer-button-actions">
                  <Button
                    label={cancelRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="neutral"
                    onClick={this.props.openUnsavedChangesModal}
                  />
                  <Button
                    id="exclusionRulesSaveButton"
                    label={saveRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="brand"
                    onClick={this.saveRules(session)}
                  />
                </div>
              </div>
            </div>
          )}
        </FlagContext.Consumer>
      );
    });
  }
}

ExclusionRulesPanel.propTypes = {
  actions: PropTypes.object,
  assetAttributes: PropTypes.array,
  profileAttributes: PropTypes.array,
  rules: PropTypes.object,
  loadedRules: PropTypes.object,
  history: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ExclusionRulesPanel);
